import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { P2GText } from '@parcel2go/core-ui';
import { getItemDisplayValuesForActions } from './getItemDisplayValuesForActions';
import { Actions } from '../../rules/Actions';
import { TariffCode } from '../../../customs/TariffCode';
import { P2GGrid } from '@parcel2go/core-ui';
import { toActionDisplayNames } from './toActionDisplayNames';

interface props {
  actions: string[];
  item: SmartSendItemApiModel;
  link?: React.ReactNode;
}

const RuleCreatePrompt: React.FC<props> = (props) => {
  return (
    <P2GGrid container spacing={1} alignItems="center">
      <P2GGrid item flexShrink={1}>
        <P2GText variant="body2">Always use {toActionDisplayNames(props.actions)}</P2GText>
      </P2GGrid>
      <P2GGrid item flexShrink={1}>
        {props.actions.length === 1 && props.actions.includes(Actions.Item_TariffCode) ? (
          <TariffCode code={getItemDisplayValuesForActions(props.item, props.actions)} selectable={false} />
        ) : (
          <P2GText variant="body2">
            <strong>{getItemDisplayValuesForActions(props.item, props.actions)}</strong>
          </P2GText>
        )}
      </P2GGrid>
      <P2GGrid item flexGrow={1} />
      {props.link && (
        <P2GGrid item flexShrink={1}>
          {props.link}
        </P2GGrid>
      )}
    </P2GGrid>
  );
};
export default RuleCreatePrompt;
